import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'opexOrgIdOptionsMapping'
})
export class OpexOrgIdOptionsMappingPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    let count = 1;
    let valueList = []
    let option = null;
    const options: { label: string, value: any }[] = args[0];
    if(value){
      valueList = value.split(',');
      option = '';
    }

    for (const val of valueList){
      let oneOption = options.find(x => x.value === val);
      const result = oneOption?.label ?? val;
      if (count == 1){
        option = option + result;
        count++;
      }else {
        option =  option + ',' + result;
      }
    }
    return option;
  }

}
